import {
  IWebsiteBuilderNodeDimensions,
  IWebsiteBuilderNodePosition,
} from "pages/secure/facility/websiteBuilder/editor/nodes/websiteBuilderNode";
import { WebsiteBuilderActionType } from "../../websiteBuilderAction";
import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/websiteBuilderRoot";
import { elementTreeTraversal } from "../../actionHelpers/elementTreeTraversal";

export interface IResizeElementActionPayload {
  id: string;
  prevPosition: IWebsiteBuilderNodePosition;
  nextPosition: IWebsiteBuilderNodePosition;
  prevDimensions: IWebsiteBuilderNodeDimensions;
  nextDimensions: IWebsiteBuilderNodeDimensions;
}

export interface IResizeElementAction {
  type: typeof WebsiteBuilderActionType.RESIZE_ELEMENT;
  payload: IResizeElementActionPayload;
}

export function getResizeElementInverseAction(action: IResizeElementAction): IResizeElementAction {
  const { id, nextPosition, prevPosition, nextDimensions, prevDimensions } = action.payload;

  return {
    type: WebsiteBuilderActionType.RESIZE_ELEMENT,
    payload: {
      id,
      prevPosition: { ...nextPosition },
      nextPosition: { ...prevPosition },
      prevDimensions: { ...nextDimensions },
      nextDimensions: { ...prevDimensions },
    },
  };
}

export function applyResizeElementTreeChange(
  tree: IWebsiteBuilderRoot,
  action: IResizeElementAction,
): IWebsiteBuilderRoot {
  const { id, nextPosition, nextDimensions } = action.payload;

  const updatedTree = elementTreeTraversal(tree, id, {
    position: { ...nextPosition },
    dimensions: { ...nextDimensions },
  });

  return updatedTree;
}
